/**
 * Resource Type Registry
 * Centralized configuration for LoadSEER API resource types
 */

import type { FC } from 'react';
import type { ResourceViewProps } from '../../types';
import { NodeGeometriesView } from './NodeGeometriesView';
import { AdjustmentsView } from './AdjustmentsView';

// ============================================================================
// Types
// ============================================================================

export interface ResourceTypeConfig {
  id: string;
  label: string;
  component: FC<ResourceViewProps>;
  description?: string;
}

// ============================================================================
// Registry
// ============================================================================

/**
 * Available resource types in LoadSEER API
 * Add new types here as they become available
 */
export const RESOURCE_TYPES: ResourceTypeConfig[] = [
  {
    id: 'node-geometries',
    label: 'Hierarchy Coverage',
    component: NodeGeometriesView,
    description: 'Search and load node geometries with hierarchy coverage',
  },
  {
    id: 'adjustments',
    label: 'Adjustments',
    component: AdjustmentsView,
    description: 'Load and visualize spatial, user, and new growth adjustments',
  },
  // Future types:
  // {
  //   id: 'network-analysis',
  //   label: 'Network Analysis',
  //   component: NetworkAnalysisView,
  //   description: 'Run and visualize network analysis results',
  // },
  // {
  //   id: 'load-forecasts',
  //   label: 'Load Forecasts',
  //   component: LoadForecastsView,
  //   description: 'View and analyze load forecast data',
  // },
];

/**
 * Get resource type config by ID
 */
export function getResourceType(id: string): ResourceTypeConfig | undefined {
  return RESOURCE_TYPES.find(type => type.id === id);
}

/**
 * Get default resource type (first in list)
 */
export function getDefaultResourceType(): ResourceTypeConfig {
  return RESOURCE_TYPES[0];
}
